/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typeppt': {
    width: 200,
    height: 233.186,
    viewBox: '0 0 200 233.186',
    data: '<g fill-rule="evenodd"><path pid="0" d="M200 196.39V61.84c0-8.29-3.29-16.24-9.15-22.1L160.26 9.15A31.252 31.252 0 00138.16 0H36.8C16.47 0 0 16.48 0 36.8v159.59c0 20.32 16.48 36.8 36.8 36.8h126.4c20.33 0 36.8-16.48 36.8-36.8z" _fill="#ff8278"/><path pid="1" d="M160.258 9.156a31.222 31.222 0 00-16.08-8.57v34.34c0 10.9 8.84 19.74 19.74 19.74h35.24a31.224 31.224 0 00-8.31-14.92l-30.59-30.59z" _fill="#ffb7b3"/><g _fill="#fff"><path pid="2" d="M71.172 156.939h15.36v-81.53h-15.36v81.53z"/><path pid="3" d="M104.262 90.195c1.86 0 3.49.43 4.9 1.27 1.41.83 2.49 2.03 3.25 3.59.77 1.55 1.15 3.34 1.15 5.35 0 1.99-.38 3.74-1.17 5.27-.79 1.53-1.87 2.72-3.28 3.56-1.41.84-3.01 1.27-4.85 1.27h-26.08v14.76h25.67c5.07 0 9.55-1.03 13.42-3.09 3.88-2.03 6.87-4.95 9-8.7 2.13-3.76 3.2-8.11 3.2-13.09 0-4.95-1.07-9.33-3.2-13.11-2.13-3.78-5.15-6.7-9-8.78-3.85-2.08-8.35-3.11-13.42-3.11h-25.67v14.81h26.08z"/></g></g>'
  }
})
